import "./ServicesPage.css";
import "../../index.css"
import cn from "classnames"
import React from "react";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import Faq from "../../components/Faqs/Faqs";
import webHeader from '../../assets/Services-Page-Assets/web-header.png';
import WebUnder from '../../assets/Services-Page-Assets/web-under.png';
import digiHeader from '../../assets/Services-Page-Assets/digi-header.png';
import digiUnder from '../../assets/Services-Page-Assets/digi-under.png';
import mobiHeader from '../../assets/Services-Page-Assets/mobi-header.png';
import mobiUnder from '../../assets/Services-Page-Assets/mobi-under.png';
import grapHeader from '../../assets/Services-Page-Assets/grap-header.png';
import grapUnder from '../../assets/Services-Page-Assets/grap-under.png';
import suppHeader from '../../assets/Services-Page-Assets/supp-header.png';
import suppUnder from '../../assets/Services-Page-Assets/supp-under.png';
import consHeader from '../../assets/Services-Page-Assets/cons-header.png';
import consUnder from '../../assets/Services-Page-Assets/cons-under.png';
import vector1 from '../../assets/Services-Page-Assets/vector-1.svg';
import vector2 from '../../assets/Services-Page-Assets/vector-2.svg';
import Button from "../../components/Buttons/Button";

function SectionHeader({imageUrl, children}){
  return(
    <div className="services-section-header" style={{ backgroundImage: `url(${imageUrl})`}}>
          <div className="body">
            <h3 className="child">
              {children}
            </h3>
          </div>
    </div>
  )
}

function SectionContent({imageUrl, alternate,children}){
  return(
    <div className="services-section-content">
      <div className="container">
      <div className={cn({
        "content-body": true,
        "content-body-alternate": alternate
      })}>
        <div className="child-parent">
          <p className="child">
            {children}
          </p>
          <Button text="Hire Us" page="/hire-us" />
        </div>
        <div className="border border-blue-900"> </div>
        <div className="img-parent">
          <img className="img" src={imageUrl}>
          </img>
        </div>
      </div>
      </div>
      
  </div>
  )
}


const ServicesPage = () => {
  return (
    <div className="services-page">
      <img className="img1" src={vector2}></img>
      <img className="img2" src={vector1}></img>
      <NavBar />
      <div className="services-header">
        <div className="services-header-body">
          <h1 className="services-heading">
            Services
          </h1>
          <p className="services-heading-paragraph">
            At Belsoft Systems Ltd, we offer a range of services tailored to meet diverse technological 
            needs for businesses, individuals, and clients alike.
          </p>
        </div>
      </div>
      <SectionHeader imageUrl={webHeader}>
        Web Development
      </SectionHeader>
      <SectionContent imageUrl={WebUnder}>
        Our web development service focuses on creating dynamic and user-friendly websites tailored to meet the unique needs of our clients. 
        We specialize in both frontend and backend development, ensuring a seamless and engaging user experience. 
        Our focus is on customized web solutions that align with client objectives, emphasizing responsiveness and scalability.Belsoft Systems excels in delivering high-quality, 
        visually appealing websites with intuitive navigation, optimized for performance and functionality.
      </SectionContent>
      <SectionHeader imageUrl={digiHeader}>
        Digital Marketing
      </SectionHeader>
      <SectionContent imageUrl={digiUnder} alternate={true}>
        Our digital marketing service is a comprehensive solution covering various online channels. 
        We focus on boosting online visibility, engagement, and conversion through strategic campaigns. 
        We specialize in Targeted and data-driven digital marketing strategies, including SEO, social media, and content marketing. 
        Belsoft Systems delivers measurable results, leveraging analytics to refine and optimize campaigns for maximum impact and return on investment.
      </SectionContent>
      <SectionHeader imageUrl={mobiHeader}>
        Mobile Development
      </SectionHeader>
      <SectionContent imageUrl={mobiUnder}>
        Belsoft Systems specializes in developing mobile applications for iOS, Android, and cross-platform environments. 
        Our mobile apps are designed to meet the demands of modern users while leveraging the latest technologies. 
        We create user-centric mobile experiences with a strong emphasis on functionality, performance, and aesthetics.
        We deliver mobile applications that not only meet technical specifications but also exceed user expectations, ensuring a positive impact on our clients' target audiences.
      </SectionContent>
      <SectionHeader imageUrl={grapHeader}>
        Graphics Design
      </SectionHeader>
      <SectionContent imageUrl={grapUnder} alternate={true}>
        Belsoft Systems offers creative and visually appealing graphics design services. 
        From branding to user interface design, our graphics team ensures a cohesive and memorable visual identity for our clients. 
        We are big on Design solutions that convey brand messages effectively and enhance user experience. 
        Our design team combines creativity with functionality, delivering graphics that captivate audiences and contribute to the overall success of our clients' projects.
      </SectionContent>
      <SectionHeader imageUrl={suppHeader}>
        IT Support & Maintenance
      </SectionHeader>
      <SectionContent imageUrl={suppUnder}>
        We provide ongoing IT support and maintenance services to ensure the optimal performance and reliability of our clients' systems and applications. 
        Proactive monitoring, regular updates, and responsive assistance to address issues promptly, that’s our goal.
        Belsoft Systems is committed to maintaining the health and efficiency of IT infrastructures, minimizing downtime, and maximizing productivity.
      </SectionContent>
      <SectionHeader imageUrl={consHeader}>
        IT Consultant
      </SectionHeader>
      <SectionContent imageUrl={consUnder} alternate={true}>
        Our IT consulting service provides expert guidance for technology-driven business decisions. 
        We collaborate with clients to develop technology roadmaps aligned with their business goals. 
        We focus on Strategic planning, risk assessment, and technology roadmapping. 
        Belsoft Systems consultants bring extensive industry knowledge, offering insights and recommendations that align with clients' long-term objectives.
      </SectionContent>
      <Faq itIsExpandable={false}></Faq>
      <Footer/>
    </div>
  );
};

export default ServicesPage;
